import PropTypes from 'prop-types';
import theme from '../../../styles/theme';

const Text = ({
  children,
  block,
  paragraph,
  size,
  strong,
  underline,
  delete: del,
  color,
  mark,
  code,
  ...props
}) => {
  let Tag;
  if (block) {
    Tag = 'div';
  } else {
    Tag = paragraph ? 'p' : 'span';
  }

  const fontStyle = {
    fontSize: theme.fontSizes[size],
    fontWeight: strong ? 'bold' : undefined,
    textDecoration: underline ? 'underline' : undefined,
    lineHeight: theme.fontStyles.lineHeight,
    color,
  };

  let node = children;
  if (mark) {
    node = <mark>{children}</mark>;
  }

  if (code) {
    node = <code>{children}</code>;
  }

  if (del) {
    node = <del>{children}</del>;
  }

  return <Tag style={{ ...fontStyle, ...props.style }}>{node}</Tag>;
};

Text.defaultProps = {
  block: true,
  size: 'base',
  paragraph: false,
  delete: false,
  mark: false,
  strong: false,
  code: false,
  underline: false,
  color: theme.colors.fontBase,
  style: {},
};

Text.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'md', 'lg']),
  block: PropTypes.bool,
  paragraph: PropTypes.bool,
  delete: PropTypes.bool,
  code: PropTypes.bool,
  mark: PropTypes.bool,
  strong: PropTypes.bool,
  underline: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.object,
};

export default Text;
